import React from 'react'
import PlatformLink, { platformLinkToString } from '@app/components/ui/buttons/PlatformLink'

import SVG from 'react-inlinesvg'
import portfolioPicture from '@src/images/backgrounds/portfolio'
import classnames from 'classnames'

const notice = () => {
  return {
    __html: I18n.t('awards.portfolio_text', {
      platform: platformLinkToString({
        className: 'link link--blue',
        sso: false,
        theme: 'lowercase'
      })
    })
  }
}

const PortfolioInfo = ({ className }) => {
  return (
    <div className={
           classnames("plate plate--info plate--xl mb-gutter-m p-2", className)
         }
    >
      <div className="grid grid--sm-1 grid--md-2--kv grid--xl-2--kv">
        <div className="mobile-only">
          <SVG src={portfolioPicture} />
        </div>

        <div className="grid">
          <p className="plate-content f--l text-left" dangerouslySetInnerHTML={ notice() } />
          <div className="grid grid--md-2 grid--xl-2">
            <PlatformLink
               sso
               className="btn f--upper"
               text={
                I18n.t('common.go_to_platform', {
                  platform: platformLinkToString({ onlyName: true })
                })
              }
            />
          </div>
        </div>

        <div className="hide-mobile">
          <SVG src={portfolioPicture}/>
        </div>
      </div>
    </div>
  )
}

export default PortfolioInfo
